export default "__VITE_ASSET__DEN11W8S__"